import axios from "axios";

const API = axios.create({
  baseURL: "https://api.mytrip4u.com/api/v1",
});

export const fetchHotels = (params) => {
  return API.get("/hotels", { params });
};

export const fetchHotelPhotos = (hotelId) => {
  return API.get(`/hotels/${hotelId}/photos`);
};

export const fetchRestaurants = (params) => {
  return API.get("/restaurants", { params });
};

export const fetchRestaurantPhotos = (restaurantId) => {
  return API.get(`/restaurants/${restaurantId}/photos`);
};

export const sendContact = (data) => {
  return API.post('/contact', data);
};
